import { BusMessage, calcStringByteLength, MessageFactory, UID_SAFE_BYTES_PER_ELEMENT } from "flavr-common";
export class CreateSharedArrayMessage extends BusMessage {
    get byteLength() {
        return calcStringByteLength(this.id) + calcStringByteLength(this.sharedType) + UID_SAFE_BYTES_PER_ELEMENT;
    }
    constructor(id, sharedType, uId) {
        super();
        this.id = id;
        this.sharedType = sharedType;
        this.uId = uId;
    }
    serialization(stream) {
        this.id = stream.utf16String(this.id);
        this.sharedType = stream.utf16String(this.sharedType);
        this.uId = stream.uidSafe(this.uId);
    }
    static is(msg) {
        return msg.type === CreateSharedArrayMessage.typestatic;
    }
}
CreateSharedArrayMessage.typestatic = "CreateSharedArrayMessage";
CreateSharedArrayMessage.subjectstatic = "general";
MessageFactory.register(CreateSharedArrayMessage);
export class DestroySharedArrayMessage extends BusMessage {
    get byteLength() {
        return calcStringByteLength(this.id) + calcStringByteLength(this.sharedType);
    }
    constructor(id, sharedType) {
        super();
        this.id = id;
        this.sharedType = sharedType;
    }
    serialization(stream) {
        this.id = stream.utf16String(this.id);
        this.sharedType = stream.utf16String(this.sharedType);
    }
    static is(msg) {
        return msg.type === DestroySharedArrayMessage.typestatic;
    }
}
DestroySharedArrayMessage.typestatic = "DestroySharedArrayMessage";
DestroySharedArrayMessage.subjectstatic = "general";
MessageFactory.register(DestroySharedArrayMessage);
export class SharedArrayBufferMessage extends BusMessage {
    get byteLength() {
        return SharedArrayBufferMessage.NUM_BYTES;
    }
    constructor(id, buffer) {
        super();
        this.id = id;
        this.buffer = buffer;
    }
    serialization() { }
    static is(msg) {
        return msg.type === SharedArrayBufferMessage.typestatic;
    }
}
SharedArrayBufferMessage.typestatic = "SharedArrayBufferMessage";
SharedArrayBufferMessage.subjectstatic = "local";
SharedArrayBufferMessage.NUM_BYTES = 0;
MessageFactory.register(SharedArrayBufferMessage);
